// extracted by mini-css-extract-plugin
export default {"gearCheck":"OrgsMenuEditGear_gearCheck__Zy2Sb","gearHeader":"OrgsMenuEditGear_gearHeader__JIt5I","placeHolderShimmer":"OrgsMenuEditGear_placeHolderShimmer__g3NxB"};